/* global axios */
import ApiClient from '../ApiClient';

class WhatsappChannel extends ApiClient {
  constructor() {
    super('whatsapp', { accountScoped: true });
  }

  createEmbeddedSignup(params) {
    return axios.post(`${this.baseUrl()}/whatsapp/authorization`, params);
  }

  reauthorizeWhatsApp({ inboxId, ...params }) {
    return axios.post(`${this.baseUrl()}/whatsapp/authorization`, {
      ...params,
      inbox_id: inboxId,
    });
  }

  getTemplates(inboxId) {
    return axios.get(`${this.baseUrl()}/whatsapp/templates`, {
      params: { inbox_id: inboxId },
    });
  }

  createTemplate(inboxId, data) {
    return axios.post(`${this.baseUrl()}/whatsapp/templates`, {
      ...data,
      inbox_id: inboxId,
    });
  }

  uploadTemplateMedia(inboxId, file, templateType) {
    const data = new FormData();
    data.append('inbox_id', inboxId);
    data.append('templateType', templateType);
    data.append('file', file);

    return axios.post(
      `${this.baseUrl()}/whatsapp/templates/upload_media`,
      data
    );
  }

  updateTemplate(inboxId, templateId, data) {
    return axios.put(`${this.baseUrl()}/whatsapp/templates/${templateId}`, {
      ...data,
      inbox_id: inboxId,
    });
  }

  deleteTemplate(inboxId, templateId, elementName) {
    return axios.delete(`${this.baseUrl()}/whatsapp/templates/${templateId}`, {
      params: { inbox_id: inboxId, element_name: elementName },
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.baseUrl()}/whatsapp/templates/sync`, {
      inbox_id: inboxId,
    });
  }
}

export default new WhatsappChannel();
